import React from 'react';
import { useAdmin } from './AdminContext';
import { Card, CardContent } from '../components/ui/card';
import { BarChart3, FileText, TrendingUp } from 'lucide-react';

export default function AdminReports() {
  const { user } = useAdmin();

  return (
    <div data-testid="admin-reports">
      <h1 className="text-2xl font-bold mb-2" style={{ color: '#1B2A6B', fontFamily: 'Chivo, sans-serif' }}>Financial Reports</h1>
      <p className="text-sm text-gray-500 mb-8">Overview of financial data and reports</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="border border-gray-200">
          <CardContent className="p-6 text-center">
            <div className="w-14 h-14 rounded-xl mx-auto mb-4 flex items-center justify-center" style={{ background: '#1B2A6B15' }}>
              <BarChart3 className="w-7 h-7" style={{ color: '#1B2A6B' }} />
            </div>
            <h3 className="font-semibold mb-1" style={{ color: '#1B2A6B' }}>Revenue Reports</h3>
            <p className="text-sm text-gray-400">Coming soon — monthly and quarterly revenue tracking</p>
          </CardContent>
        </Card>
        <Card className="border border-gray-200">
          <CardContent className="p-6 text-center">
            <div className="w-14 h-14 rounded-xl mx-auto mb-4 flex items-center justify-center" style={{ background: '#B8962E15' }}>
              <FileText className="w-7 h-7" style={{ color: '#B8962E' }} />
            </div>
            <h3 className="font-semibold mb-1" style={{ color: '#1B2A6B' }}>Accounts Payable</h3>
            <p className="text-sm text-gray-400">Coming soon — vendor payment tracking and aging</p>
          </CardContent>
        </Card>
        <Card className="border border-gray-200">
          <CardContent className="p-6 text-center">
            <div className="w-14 h-14 rounded-xl mx-auto mb-4 flex items-center justify-center" style={{ background: '#10B98115' }}>
              <TrendingUp className="w-7 h-7" style={{ color: '#10B981' }} />
            </div>
            <h3 className="font-semibold mb-1" style={{ color: '#1B2A6B' }}>Profit & Loss</h3>
            <p className="text-sm text-gray-400">Coming soon — P&L statements and margin analysis</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
